export default __webpack_public_path__ + "static/media/pan.ef47b30f.jpg";